/**
 * @generated SignedSource<<b7e464c63f4bf1d24aa38a6728f48c90>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scheduleTemplateId"
        }
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v2 = [
        (v1 /*: any*/)
    ], v3 = {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "currentCompany",
        "plural": false,
        "selections": (v2 /*: any*/),
        "storageKey": null
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "scheduleTemplateId"
        }
    ], v5 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        }
    ], v6 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "unit",
                "value": "DAY"
            }
        ],
        "concreteType": "TimeSpanUnitValue",
        "kind": "LinkedField",
        "name": "periodDuration",
        "plural": false,
        "selections": (v5 /*: any*/),
        "storageKey": "periodDuration(unit:\"DAY\")"
    }, v7 = [
        {
            "kind": "Literal",
            "name": "order",
            "value": {
                "order": "ASC"
            }
        }
    ], v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentUserPermissions",
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "concreteType": "AssignmentType",
        "kind": "LinkedField",
        "name": "assignmentType",
        "plural": false,
        "selections": [
            (v1 /*: any*/),
            (v13 /*: any*/)
        ],
        "storageKey": null
    }, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
    }, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v17 = {
        "kind": "InlineFragment",
        "selections": (v2 /*: any*/),
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
    }, v20 = [
        (v1 /*: any*/),
        (v11 /*: any*/)
    ], v21 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "SchedulableEntityEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v8 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        (v19 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "SchedulableUser",
                            "abstractKey": null
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Asset",
                                    "kind": "LinkedField",
                                    "name": "asset",
                                    "plural": false,
                                    "selections": (v20 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "type": "SchedulableAsset",
                            "abstractKey": null
                        },
                        (v17 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ], v22 = [
        (v11 /*: any*/),
        (v1 /*: any*/)
    ], v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstname",
        "storageKey": null
    }, v24 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastname",
        "storageKey": null
    }, v25 = [
        (v13 /*: any*/),
        (v1 /*: any*/)
    ], v26 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "weekday",
        "storageKey": null
    }, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endTimeOfDay",
        "storageKey": null
    }, v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startTimeOfDay",
        "storageKey": null
    }, v29 = {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
            (v1 /*: any*/),
            (v16 /*: any*/),
            (v11 /*: any*/)
        ],
        "storageKey": null
    }, v30 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dayInPeriod",
        "storageKey": null
    }, v31 = [
        {
            "kind": "Literal",
            "name": "unit",
            "value": "MINUTE"
        }
    ], v32 = {
        "alias": null,
        "args": null,
        "concreteType": "ScheduleTemplateShiftBreak",
        "kind": "LinkedField",
        "name": "breaks",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": (v31 /*: any*/),
                "concreteType": "TimeSpanUnitValue",
                "kind": "LinkedField",
                "name": "offsetEnd",
                "plural": false,
                "selections": (v5 /*: any*/),
                "storageKey": "offsetEnd(unit:\"MINUTE\")"
            },
            {
                "alias": null,
                "args": (v31 /*: any*/),
                "concreteType": "TimeSpanUnitValue",
                "kind": "LinkedField",
                "name": "offsetStart",
                "plural": false,
                "selections": (v5 /*: any*/),
                "storageKey": "offsetStart(unit:\"MINUTE\")"
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v33 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scheduleTemplateId",
        "storageKey": null
    }, v34 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entityDisabled",
        "storageKey": null
    }, v35 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schedulable",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ScheduleTemplateDetailsPageQuery",
            "selections": [
                (v3 /*: any*/),
                {
                    "alias": null,
                    "args": (v4 /*: any*/),
                    "concreteType": "ScheduleTemplate",
                    "kind": "LinkedField",
                    "name": "scheduleTemplate",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ScheduleTemplateHeader_scheduleTemplate"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ScheduleTemplateSidebar_scheduleTemplate"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ScheduleTemplateEditNavbar_scheduleTemplate"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ScheduleTemplateInformationDrawer"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ScheduleTemplateEditTimeModal_shifts"
                        },
                        (v6 /*: any*/),
                        {
                            "alias": "periods",
                            "args": (v7 /*: any*/),
                            "concreteType": "ScheduleTemplatePeriodConnection",
                            "kind": "LinkedField",
                            "name": "__ScheduleTemplate_periods_connection",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleTemplatePeriodEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleTemplatePeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "ScheduleTemplatePeriod_period"
                                                },
                                                (v8 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v9 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v10 /*: any*/)
                            ],
                            "storageKey": "__ScheduleTemplate_periods_connection(order:{\"order\":\"ASC\"})"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ScheduleTemplateDetailsPageQuery",
            "selections": [
                (v3 /*: any*/),
                {
                    "alias": null,
                    "args": (v4 /*: any*/),
                    "concreteType": "ScheduleTemplate",
                    "kind": "LinkedField",
                    "name": "scheduleTemplate",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v11 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Schedule",
                            "kind": "LinkedField",
                            "name": "schedule",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                (v12 /*: any*/),
                                (v11 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleAssignmentTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "assignmentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleAssignmentTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleAssignmentType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        (v14 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleAssignmentTypeResourceConnection",
                                                            "kind": "LinkedField",
                                                            "name": "resources",
                                                            "plural": false,
                                                            "selections": [
                                                                (v15 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleAssignmentTypeResourceEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ScheduleAssignmentTypeResource",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v1 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "schedulableEntity",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v8 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                (v1 /*: any*/),
                                                                                                (v16 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "displayName",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "Asset",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "asset",
                                                                                                            "plural": false,
                                                                                                            "selections": (v2 /*: any*/),
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "SchedulableAsset",
                                                                                                    "abstractKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "ISchedulableEntity",
                                                                                            "abstractKey": "__isISchedulableEntity"
                                                                                        },
                                                                                        (v17 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Schedule",
                                                            "kind": "LinkedField",
                                                            "name": "schedule",
                                                            "plural": false,
                                                            "selections": [
                                                                (v12 /*: any*/),
                                                                (v1 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "scheduleId",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": "checked",
                                    "args": (v18 /*: any*/),
                                    "concreteType": "SchedulableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "schedulableEntities",
                                    "plural": false,
                                    "selections": (v21 /*: any*/),
                                    "storageKey": "schedulableEntities(first:100)"
                                },
                                {
                                    "alias": null,
                                    "args": (v18 /*: any*/),
                                    "concreteType": "SchedulableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "schedulableEntities",
                                    "plural": false,
                                    "selections": (v21 /*: any*/),
                                    "storageKey": "schedulableEntities(first:100)"
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleTemplateShiftClashGroup",
                            "kind": "LinkedField",
                            "name": "shiftClashes",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleTemplateShift",
                                    "kind": "LinkedField",
                                    "name": "clashes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "assignedEntity",
                                            "plural": false,
                                            "selections": [
                                                (v8 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Asset",
                                                            "kind": "LinkedField",
                                                            "name": "asset",
                                                            "plural": false,
                                                            "selections": (v22 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "SchedulableAsset",
                                                    "abstractKey": null
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "User",
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                (v23 /*: any*/),
                                                                (v16 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Avatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v1 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "storageId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "queryTransform",
                                                                                    "value": "width=68&height=68&mode=crop&scale=both"
                                                                                }
                                                                            ],
                                                                            "kind": "ScalarField",
                                                                            "name": "url",
                                                                            "storageKey": "url(queryTransform:\"width=68&height=68&mode=crop&scale=both\")"
                                                                        },
                                                                        {
                                                                            "alias": "imageUrl",
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "queryTransform",
                                                                                    "value": "width=400&height=400&mode=crop&scale=both"
                                                                                }
                                                                            ],
                                                                            "kind": "ScalarField",
                                                                            "name": "url",
                                                                            "storageKey": "url(queryTransform:\"width=400&height=400&mode=crop&scale=both\")"
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v19 /*: any*/),
                                                                (v1 /*: any*/),
                                                                (v24 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "SchedulableUser",
                                                    "abstractKey": null
                                                },
                                                (v17 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v1 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AssignmentType",
                                            "kind": "LinkedField",
                                            "name": "assignmentType",
                                            "plural": false,
                                            "selections": (v25 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleTemplatePeriodDay",
                                            "kind": "LinkedField",
                                            "name": "day",
                                            "plural": false,
                                            "selections": [
                                                (v26 /*: any*/),
                                                (v1 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v27 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleTemplatePeriod",
                                            "kind": "LinkedField",
                                            "name": "period",
                                            "plural": false,
                                            "selections": (v22 /*: any*/),
                                            "storageKey": null
                                        },
                                        (v28 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleTemplateShiftConnection",
                            "kind": "LinkedField",
                            "name": "shifts",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleTemplateShiftEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleTemplateShift",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "assignmentTypeId",
                                                    "storageKey": null
                                                },
                                                (v1 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "assignedEntity",
                                                    "plural": false,
                                                    "selections": [
                                                        (v8 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v1 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "User",
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v1 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v23 /*: any*/),
                                                                        (v24 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "SchedulableUser",
                                                            "abstractKey": null
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v1 /*: any*/),
                                                                (v29 /*: any*/)
                                                            ],
                                                            "type": "SchedulableAsset",
                                                            "abstractKey": null
                                                        },
                                                        (v17 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleTemplatePeriodDay",
                                                    "kind": "LinkedField",
                                                    "name": "day",
                                                    "plural": false,
                                                    "selections": [
                                                        (v30 /*: any*/),
                                                        (v1 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v27 /*: any*/),
                                                (v28 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleTemplatePeriod",
                                                    "kind": "LinkedField",
                                                    "name": "period",
                                                    "plural": false,
                                                    "selections": (v2 /*: any*/),
                                                    "storageKey": null
                                                },
                                                (v32 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v7 /*: any*/),
                            "concreteType": "ScheduleTemplatePeriodConnection",
                            "kind": "LinkedField",
                            "name": "periods",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleTemplatePeriodEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleTemplatePeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                (v11 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "order",
                                                    "storageKey": null
                                                },
                                                (v8 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleTemplatePeriodDayConnection",
                                                    "kind": "LinkedField",
                                                    "name": "days",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleTemplatePeriodDayEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleTemplatePeriodDay",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v1 /*: any*/),
                                                                        (v26 /*: any*/),
                                                                        (v30 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ScheduleTemplatePeriod",
                                                                            "kind": "LinkedField",
                                                                            "name": "period",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v1 /*: any*/),
                                                                                (v33 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ScheduleTemplatePeriodDayShiftGroupByAssignmentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "groupedShifts",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ScheduleTemplatePeriodDayShiftGroupByAssignmentTypeGroupingKey",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "group",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v14 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ScheduleTemplateShiftGroup",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "shiftsGroups",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "ScheduleTemplateShiftGroupGroupingKey",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v28 /*: any*/),
                                                                                                (v27 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": (v31 /*: any*/),
                                                                                                    "concreteType": "TimeSpanUnitValue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "duration",
                                                                                                    "plural": false,
                                                                                                    "selections": (v5 /*: any*/),
                                                                                                    "storageKey": "duration(unit:\"MINUTE\")"
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Event",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "event",
                                                                                                    "plural": false,
                                                                                                    "selections": (v20 /*: any*/),
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "ScheduleTemplateShift",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "shifts",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                (v1 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "unit",
                                                                                                            "value": "HOUR"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "TimeSpanUnitValue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "duration",
                                                                                                    "plural": false,
                                                                                                    "selections": (v5 /*: any*/),
                                                                                                    "storageKey": "duration(unit:\"HOUR\")"
                                                                                                },
                                                                                                (v14 /*: any*/),
                                                                                                (v32 /*: any*/),
                                                                                                (v27 /*: any*/),
                                                                                                (v28 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": null,
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "assignedEntity",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v8 /*: any*/),
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                (v1 /*: any*/),
                                                                                                                (v29 /*: any*/),
                                                                                                                (v34 /*: any*/),
                                                                                                                (v35 /*: any*/)
                                                                                                            ],
                                                                                                            "type": "SchedulableAsset",
                                                                                                            "abstractKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                (v1 /*: any*/),
                                                                                                                (v34 /*: any*/),
                                                                                                                (v35 /*: any*/),
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "User",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "user",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v1 /*: any*/),
                                                                                                                        (v16 /*: any*/),
                                                                                                                        (v19 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "SchedulableUser",
                                                                                                            "abstractKey": null
                                                                                                        },
                                                                                                        (v17 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "ScheduleShiftAssetValidation",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "assetValidations",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "SchedulableAsset",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "schedulableAsset",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Asset",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "asset",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v1 /*: any*/),
                                                                                                                        (v11 /*: any*/),
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "assetNumber",
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "validateProficiency",
                                                                                                                            "storageKey": null
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v1 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "SchedulableUser",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "schedulableUser",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "User",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "user",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v19 /*: any*/),
                                                                                                                        (v1 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v1 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "AssignmentType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "userAssignmentType",
                                                                                                            "plural": false,
                                                                                                            "selections": (v25 /*: any*/),
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "AssetProficiencyValidation",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "assetProficiency",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isValid",
                                                                                                                    "storageKey": null
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v33 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v9 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v15 /*: any*/),
                                (v10 /*: any*/)
                            ],
                            "storageKey": "periods(order:{\"order\":\"ASC\"})"
                        },
                        {
                            "alias": null,
                            "args": (v7 /*: any*/),
                            "filters": [
                                "order"
                            ],
                            "handle": "connection",
                            "key": "ScheduleTemplate_periods",
                            "kind": "LinkedHandle",
                            "name": "periods"
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "preliminaryStartDate",
                            "storageKey": null
                        },
                        (v6 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "233dd917aa24799d4c08576f3491fec5",
            "id": null,
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "scheduleTemplate",
                            "periods"
                        ]
                    }
                ]
            },
            "name": "ScheduleTemplateDetailsPageQuery",
            "operationKind": "query",
            "text": "query ScheduleTemplateDetailsPageQuery(\n  $scheduleTemplateId: ID!\n) {\n  currentCompany {\n    id\n  }\n  scheduleTemplate(id: $scheduleTemplateId) {\n    id\n    ...ScheduleTemplateHeader_scheduleTemplate\n    ...ScheduleTemplateSidebar_scheduleTemplate\n    ...ScheduleTemplateEditNavbar_scheduleTemplate\n    ...ScheduleTemplateInformationDrawer\n    ...ScheduleTemplateEditTimeModal_shifts\n    periodDuration(unit: DAY) {\n      value\n    }\n    periods(order: {order: ASC}) {\n      edges {\n        node {\n          id\n          ...ScheduleTemplatePeriod_period\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment SchedulableAsset_entity on SchedulableAsset {\n  id\n  asset {\n    id\n    color\n    name\n  }\n  entityDisabled\n  schedulable\n}\n\nfragment SchedulableUser_entity on SchedulableUser {\n  id\n  entityDisabled\n  schedulable\n  user {\n    id\n    color\n    fullName\n  }\n}\n\nfragment ScheduleAssignmentType_scheduleAssignmentType on ScheduleAssignmentType {\n  id\n  assignmentType {\n    id\n    title\n  }\n  resources {\n    edges {\n      node {\n        id\n        schedulableEntity {\n          __typename\n          ... on ISchedulableEntity {\n            __isISchedulableEntity: __typename\n            id\n            color\n            displayName\n            ... on SchedulableAsset {\n              asset {\n                id\n              }\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n  schedule {\n    currentUserPermissions\n    id\n  }\n  scheduleId\n}\n\nfragment ScheduleTemplateAssignmentTypeFilter_assignmentTypes on Schedule {\n  id\n  assignmentTypes {\n    edges {\n      node {\n        id\n        assignmentType {\n          id\n          title\n        }\n      }\n    }\n  }\n}\n\nfragment ScheduleTemplateEditNavbar_scheduleTemplate on ScheduleTemplate {\n  id\n  periods(order: {order: ASC}) {\n    ...SortPeriodsModal_scheduleTemplatePeriodConnection\n    totalCount\n  }\n}\n\nfragment ScheduleTemplateEditTimeModal_shifts on ScheduleTemplate {\n  id\n  shifts {\n    edges {\n      node {\n        id\n        day {\n          dayInPeriod\n          id\n        }\n        endTimeOfDay\n        startTimeOfDay\n        period {\n          id\n        }\n        breaks {\n          offsetEnd(unit: MINUTE) {\n            value\n          }\n          offsetStart(unit: MINUTE) {\n            value\n          }\n          type\n        }\n      }\n    }\n  }\n}\n\nfragment ScheduleTemplateHeader_scheduleTemplate on ScheduleTemplate {\n  id\n  name\n  schedule {\n    id\n    currentUserPermissions\n    name\n    ...ScheduleTemplateAssignmentTypeFilter_assignmentTypes\n    ...ScheduleTemplateResourceFilterList_resources\n  }\n  ...ScheduleTemplateShiftClashes_scheduleTemplate\n}\n\nfragment ScheduleTemplateInformationDrawer on ScheduleTemplate {\n  id\n  preliminaryStartDate\n  periods(order: {order: ASC}) {\n    edges {\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ScheduleTemplatePeriodDay_day on ScheduleTemplatePeriodDay {\n  id\n  dayInPeriod\n  weekday\n  period {\n    id\n    scheduleTemplateId\n  }\n  groupedShifts {\n    group {\n      assignmentType {\n        id\n        title\n      }\n    }\n    shiftsGroups {\n      group {\n        startTimeOfDay\n        endTimeOfDay\n        duration(unit: MINUTE) {\n          value\n        }\n        event {\n          id\n          name\n        }\n      }\n      shifts {\n        id\n        duration(unit: HOUR) {\n          value\n        }\n        assignmentType {\n          id\n          title\n        }\n        breaks {\n          offsetEnd(unit: MINUTE) {\n            value\n          }\n          offsetStart(unit: MINUTE) {\n            value\n          }\n          type\n        }\n        endTimeOfDay\n        startTimeOfDay\n        ...ScheduleTemplateShift_shift\n      }\n      ...ScheduleTemplateShiftAssetValidationGroup_scheduleTemplateShift\n    }\n  }\n}\n\nfragment ScheduleTemplatePeriod_period on ScheduleTemplatePeriod {\n  id\n  days {\n    edges {\n      node {\n        id\n        weekday\n        ...ScheduleTemplatePeriodDay_day\n      }\n    }\n  }\n  name\n  scheduleTemplateId\n}\n\nfragment ScheduleTemplateResourceFilterList_resources on Schedule {\n  id\n  checked: schedulableEntities(first: 100) {\n    edges {\n      node {\n        __typename\n        ... on SchedulableUser {\n          id\n          user {\n            id\n            fullName\n          }\n        }\n        ... on SchedulableAsset {\n          id\n          asset {\n            id\n            name\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  schedulableEntities(first: 100) {\n    edges {\n      node {\n        __typename\n        ... on SchedulableUser {\n          id\n          user {\n            id\n            fullName\n          }\n        }\n        ... on SchedulableAsset {\n          id\n          asset {\n            id\n            name\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ScheduleTemplateShiftAssetValidationGroup_scheduleTemplateShift on ScheduleTemplateShiftGroup {\n  shifts {\n    assetValidations {\n      schedulableAsset {\n        asset {\n          id\n          name\n          assetNumber\n          validateProficiency\n        }\n        id\n      }\n      schedulableUser {\n        user {\n          fullName\n          id\n        }\n        id\n      }\n      userAssignmentType {\n        title\n        id\n      }\n      assetProficiency {\n        isValid\n      }\n    }\n    id\n  }\n}\n\nfragment ScheduleTemplateShiftClashGroup_scheduleTemplateShiftClashGroup on ScheduleTemplateShiftClashGroup {\n  clashes {\n    id\n    assignedEntity {\n      __typename\n      ... on SchedulableAsset {\n        id\n        asset {\n          name\n          id\n        }\n      }\n      ... on SchedulableUser {\n        id\n        user {\n          ...User\n          firstname\n          lastname\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ...ScheduleTemplateShiftClash_scheduleTemplateShift\n  }\n}\n\nfragment ScheduleTemplateShiftClash_scheduleTemplateShift on ScheduleTemplateShift {\n  id\n  assignmentType {\n    title\n    id\n  }\n  day {\n    weekday\n    id\n  }\n  endTimeOfDay\n  period {\n    name\n    id\n  }\n  startTimeOfDay\n}\n\nfragment ScheduleTemplateShiftClashes_scheduleTemplate on ScheduleTemplate {\n  id\n  shiftClashes {\n    clashes {\n      assignedEntity {\n        __typename\n        ... on SchedulableAsset {\n          id\n          asset {\n            name\n            id\n          }\n        }\n        ... on SchedulableUser {\n          id\n          user {\n            ...User\n            fullName\n            id\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      id\n    }\n    ...ScheduleTemplateShiftClashGroup_scheduleTemplateShiftClashGroup\n  }\n}\n\nfragment ScheduleTemplateShift_shift on ScheduleTemplateShift {\n  id\n  assignedEntity {\n    __typename\n    ...SchedulableAsset_entity\n    ...SchedulableUser_entity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  assignmentType {\n    id\n    title\n  }\n}\n\nfragment ScheduleTemplateSidebar_scheduleTemplate on ScheduleTemplate {\n  id\n  shifts {\n    edges {\n      node {\n        assignmentTypeId\n        id\n        assignedEntity {\n          __typename\n          ... on SchedulableUser {\n            id\n            user {\n              id\n              color\n              firstname\n              lastname\n            }\n          }\n          ... on SchedulableAsset {\n            id\n            asset {\n              id\n              color\n              name\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n  schedule {\n    id\n    assignmentTypes {\n      edges {\n        node {\n          id\n          resources {\n            totalCount\n          }\n          ...ScheduleAssignmentType_scheduleAssignmentType\n          assignmentType {\n            title\n            id\n          }\n        }\n      }\n    }\n    currentUserPermissions\n  }\n}\n\nfragment SortPeriodsModal_scheduleTemplatePeriodConnection on ScheduleTemplatePeriodConnection {\n  edges {\n    node {\n      id\n      name\n      order\n    }\n  }\n}\n\nfragment User on User {\n  firstname\n  color\n  avatar {\n    id\n    storageId\n    url(queryTransform: \"width=68&height=68&mode=crop&scale=both\")\n    ...UserImageLightBox\n  }\n}\n\nfragment UserImageLightBox on Avatar {\n  imageUrl: url(queryTransform: \"width=400&height=400&mode=crop&scale=both\")\n}\n"
        }
    };
})();
node.hash = "86b35e96533a975d9320b13feed2b85f";
export default node;
